import React from 'react';
import { useTranslation } from 'react-i18next';

interface BarcodeScannerProps {
    scannerEnabled: boolean;
}

const BarcodeScannerView: React.FC<BarcodeScannerProps> = ({ scannerEnabled }) => {
    const { t } = useTranslation();

    return (
        <div className="scanner-box">
            <div className="scanner-overlay">
                <div className="corner top-left"></div>
                <div className="corner top-right"></div>
                <div className="corner bottom-left"></div>
                <div className="corner bottom-right"></div>
            </div>

            <div className="scanner-icons">
                <span className={`icon qr-icon ${scannerEnabled ? 'active' : ''}`}></span>
                <span className={`icon hardware-icon ${scannerEnabled ? 'active' : ''}`}></span>
            </div>

            <div className="scanner-text">
                {t('Barcode Scanner')} {scannerEnabled ? t('Enabled') : t('Disabled')}
            </div>
        </div>
    );
};

export default BarcodeScannerView;
